import { render } from "./monaco.vue?vue&type=template&id=41348316"
import script from "./monaco.vue?vue&type=script&lang=js"
export * from "./monaco.vue?vue&type=script&lang=js"

import exportComponent from "D:\\project\\weetgo\\doo3dexamples\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__